import { z } from "zod";

export const ZSpesielleRomOgKonstruksjonerSchema = z.object({
  // 14
  isActive: z.boolean().default(false),
  tekst: z.string(),
  vatrom: z.object({
    // 14.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  nedkjolteRom: z.object({
    // 14.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
    kjolerom: z.object({
      // 14.2.1
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
    fryserom: z.object({
      // 14.2.2
      isActive: z.boolean().default(false),
      tekst: z.string(),
    }),
  }),
  bygningerUnderGrunnvann: z.object({
    // 14.3
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  trafoRom: z.object({
    // 14.4
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  ventilasjonssjakter: z.object({
    // 14.5
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  basseng: z.object({
    // 14.6
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  badstue: z.object({
    // 14.7
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  storkjokken: z.object({
    // 14.8
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  parkeringskjeller: z.object({
    // 14.9
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  karnapp: z.object({
    // 14.10
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  sportsgulv: z.object({
    // 14.11
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
});

export type ISpesielleRomOgKonstruksjonerSchema = z.infer<typeof ZSpesielleRomOgKonstruksjonerSchema>;
